import React from 'react';
import {
  renderToStaticMarkup,
} from 'react-dom/server';
import {
  GraphExportType,
} from '../../Utils';
import SVG from './SVG';
import {
  GraphData,
} from './types';

export interface IExportsInput extends GraphData {
  exportType: GraphExportType;
}

const getSVGString = (input: IExportsInput): string => renderToStaticMarkup(
  <SVG
    width={input.width} height={input.height}
    treeMapCells={input.treeMapCells}
    total={input.total}
    exportType={input.exportType}
  />,
);

export default getSVGString;
